/**
 * TypingIndicator.js — Transient "assistant is typing" bubble.
 *
 * Mirrors TextBubble's bot row (avatar + bubble) so the indicator lines up
 * with real bot replies, but carries an animated three-dot loader. It is
 * NOT a message kind — MessageList shows/removes it directly in response
 * to the ws-chat-typing event (see MessageList._setTyping), so it never
 * enters the messages array or conversation history.
 *
 * REFERENCE (old code):
 *   thomasfogarty/script.js addLoadingAnimationAsBotResponse() (2239+)
 *   + styles.css .loader / @keyframes l1 — ported to .ws-typing-dots.
 */

import { getDefaultBotAvatar } from "./avatars.js";
import { getTheme } from "../../../core/configAccessors.js";

export default class TypingIndicator {
  render() {
    const row = document.createElement("div");
    row.className = "ws-bot-row ws-typing-row";

    const avatar = document.createElement("div");
    avatar.className = "ws-avatar ws-bot-avatar";
    const url = getTheme("bot_avatar_url", null);
    if (url) {
      const img = document.createElement("img");
      img.src = url;
      img.alt = "";
      img.onerror = () => {
        avatar.innerHTML = getDefaultBotAvatar();
      };
      avatar.appendChild(img);
    } else {
      avatar.innerHTML = getDefaultBotAvatar();
    }

    const wrap = document.createElement("div");
    wrap.className = "ws-bubble-wrap";

    const bubble = document.createElement("div");
    bubble.className = "ws-bot-bubble ws-typing";
    bubble.setAttribute("role", "status");
    bubble.setAttribute("aria-label", "Assistant is typing");
    bubble.innerHTML = '<span class="ws-typing-dots"></span>';
    wrap.appendChild(bubble);

    row.appendChild(avatar);
    row.appendChild(wrap);
    return row;
  }
}
